<div class="header-actions">
  <!-- Theme toggle -->
  <button
    class="action-button"
    mat-icon-button
    (click)="toggleTheme()"
    [matTooltip]="(isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode') | translate">
    <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>

  <!-- Language switcher -->
  <button
    class="action-button lang-button"
    mat-icon-button
    (click)="toggleLanguage()"
    [matTooltip]="'Switch language' | translate">
    {{ (translate.currentLang || translate.getDefaultLang() || 'en').toUpperCase() }}
  </button>

  <!-- Notifications -->
  <button
    class="action-button notification-button"
    mat-icon-button
    [matTooltip]="'Notifications' | translate"
    (click)="goToNotifications()">
    <mat-icon
      [matBadge]="notificationCount"
      [matBadgeHidden]="notificationCount === 0"
      matBadgeColor="warn"
      matBadgeSize="small"
      matBadgePosition="above after">
      notifications_active
    </mat-icon>
  </button>



  <mat-menu #supportMenu="matMenu">
    <!-- <button mat-menu-item routerLink="/information/help"> -->
    <!--      <span class="material-symbols-outlined">settings_suggest</span>-->
    <!-- {{ 'help' | translate }}
    </button> -->
    <!-- <button mat-menu-item routerLink="/information/about"> -->
    <!--      <span class="material-symbols-outlined">info</span>-->
    <!-- {{ 'about-amis' | translate }}
    </button> -->
  </mat-menu>
  <!-- The whole pill is the trigger (previously only the small chevron
       button was, so clicking the name/avatar — the part that visually
       looks clickable — did nothing; on narrow screens the chevron was
       hidden entirely, so there was no way to open this menu at all). -->
  <div class="flex flex-row justify-between items-center bg-[#0072BB] px-2 gap-4 py-1 rounded-md user-menu-trigger"
    [matMenuTriggerFor]="userMenu">
    <div class="flex flex-row items-center gap-2">
        <mat-icon class="text-white">account_circle</mat-icon>
      <span class="font-bold text-white"> {{firstName}} {{lastName}}</span>
    </div>
    <button class="d-none d-md-inline" mat-icon-button tabindex="-1">
      <span class="material-symbols-outlined text-white">expand_circle_down</span>
    </button>
  </div>

  <!-- User Menu Dropdown -->
  <mat-menu #userMenu="matMenu" class="user-menu" xPosition="before">
    <!-- This used to be gated behind `@if (user$ | async; as user)`, but
         user$ is never assigned (dead NgRx code, commented out in the
         constructor) and nothing in this block even reads the resolved
         `user` value — the gate always evaluated to null/false, so the
         whole menu silently rendered empty every time it opened. -->
    <!-- User Info Card -->
    <div class="user-menu-header" (click)="$event.stopPropagation()">
      <div class="user-menu-avatar">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="user-menu-info">
        <h4 class="user-menu-name">{{ firstName }} {{ lastName }}</h4>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Menu Items -->
    <!-- Change Password used to be a separate popup here; it's now a
         section on the Profile page itself (My Profile > Security), along
         with personal info, notification preferences, and account
         deletion — one real page instead of two broken dialogs. -->
    <button mat-menu-item routerLink="/profile" class="menu-item">
      <mat-icon>person</mat-icon>
      <span>{{ 'Profile' | translate }}</span>
    </button>

    <button mat-menu-item class="menu-item">
      <mat-icon>help_outline</mat-icon>
      <span>{{ 'Help & Support' | translate }}</span>
    </button>

    <mat-divider></mat-divider>

    <!-- Logout -->
    <button mat-menu-item (click)="logout()" class="menu-item logout-item">
      <mat-icon>logout</mat-icon>
      <span>{{ 'Log Out' | translate }}</span>
    </button>
  </mat-menu>
</div>
